import { designPackagesRoutes } from "src/routing/domains/libraries/design-packages/designPackages";
import { globalOptionsRoutes } from "src/routing/domains/libraries/global-options/globalOptions";
import { itemCatalogRoutes } from "src/routing/domains/libraries/item-catalog/itemCatalog";
import { librariesRootRoute } from "src/routing/domains/libraries/librariesRoot";
import { materialCatalogRoutes } from "src/routing/domains/libraries/material-catalog/materialCatalog";
import { milestoneCatalogRoutes } from "src/routing/domains/libraries/milestone-catalog/milestoneCatalog";
import { planPackagesRoute } from "src/routing/domains/libraries/plan-packages/planPackages";
import { planRoutes } from "src/routing/domains/libraries/plan/plan";
import { productOfferingConfigsRoute } from "src/routing/domains/libraries/product-offering-configs/productOfferingConfigs";
import { productOfferingsRoute } from "src/routing/domains/libraries/product-offerings/productOfferings";
import { scheduleTemplatesRoutes } from "src/routing/domains/libraries/schedule-templates/scheduleTemplates";
import { taskCatalogRoutes } from "src/routing/domains/libraries/task-catalog/taskCatalog";

/**
 * Migrated `/libraries/*` route trees registered in `Router.tsx`.
 *
 * Role: data router domain aggregate.
 *
 * Large domains use `domains/<name>/` with per-subtree folders (`*Paths.ts`, route tree, smoke tests)
 * aggregated here — see `src/routing/README.md`.
 *
 * Sibling top-level prefixes (plus `librariesRootRoute` for the `/libraries` index redirect) keep each
 * subtree independently layouted. A single `path: "/libraries"` parent remains optional follow-up.
 */
export const librariesRoutes = [
  librariesRootRoute,
  ...globalOptionsRoutes,
  scheduleTemplatesRoutes,
  materialCatalogRoutes,
  taskCatalogRoutes,
  productOfferingsRoute,
  productOfferingConfigsRoute,
  planPackagesRoute,
  milestoneCatalogRoutes,
  itemCatalogRoutes,
  planRoutes,
  designPackagesRoutes,
];
